import React from "react";

import styles from "./SubtractSwitcher.module.css"
import {SubtractionType} from "../../../api/generated";


interface SubtractSwitcherProps {
    subtractionType: SubtractionType
    setSubtractionType: (subtractionType: SubtractionType) => void
}

export const SubtractSwitcher: React.FC<SubtractSwitcherProps> = ({
                                                                      subtractionType,
                                                                      setSubtractionType
                                                                  }) => {

    const handleUpdate = () => {
        const newValue = subtractionType === SubtractionType.Percentage ?
            SubtractionType.Number : SubtractionType.Percentage
        setSubtractionType(newValue)
    }

    return <div className={styles.wrapper} onClick={e => handleUpdate()}>
        <div className={`${styles.slider} 
            ${subtractionType === SubtractionType.Percentage ? styles.sliderLeft : styles.sliderRight}`}/>
        <div onClick={() => setSubtractionType(SubtractionType.Percentage)}
             className={`${styles.cell} ${subtractionType === SubtractionType.Percentage && styles.selected}`}>
            %
        </div>
        <div onClick={() => setSubtractionType(SubtractionType.Number)}
             className={`${styles.cell} ${subtractionType === SubtractionType.Number && styles.selected}`}>
            £
        </div>
    </div>
}
